import { useContext, useEffect } from 'react'
import moment from 'moment'

import { CardContractPayments } from './ui'
import { FieldsErrorType, ICardContractPayments, ICardContractPaymentsContainer, IFieldsError } from './types'

import { useValue } from '@hooks/useValue'
import { validFormData } from '@hooks/useForm'
import { useFieldsErrorAnimation } from '@hooks/useFieldsErrorAnimation'

import { NotificationContext, notifyOpen } from '@ui/notification/notification.provider'



/** Контейнер - анкеты создания/редактирования оплат по договору */
export const CardContractPaymentsContainer = ({
    isOpen, cardMode, handlerButtonOk, handlerButtonCancel,
    paymentNumber, paymentDate, paymentSum, paymentPayer, paymentRefund,
}: ICardContractPaymentsContainer) => {
    const notify = useContext(NotificationContext)

    const fieldsError = useValue<IFieldsError>({})

    const txtPaymentRefund = useValue<number>(0)
    const txtPaymentNumber = useValue<string>('')
    const txtPaymentDate = useValue<string>(moment(new Date()).format('DD.MM.YYYY'))
    const txtPaymentSum = useValue<number | ''>('')
    const txtPaymentPayer = useValue<string>('')


    useEffect(() => {
        if (isOpen) {
            txtPaymentRefund.setValue(Number(paymentRefund) || 0)
            txtPaymentNumber.setValue(paymentNumber || '')
            txtPaymentDate.setValue(paymentDate || moment(new Date()).format('DD.MM.YYYY'))
            txtPaymentSum.setValue(paymentSum || '')
            txtPaymentPayer.setValue(paymentPayer || '')
        }

        !isOpen && clearData()
    }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    const clearData = () => {
        fieldsError.setValue({})

        txtPaymentRefund.setValue(0)
        txtPaymentNumber.setValue('')
        txtPaymentDate.setValue(moment(new Date()).format('DD.MM.YYYY'))
        txtPaymentSum.setValue('')
        txtPaymentPayer.setValue('')
    }

    /** Кнопка сохранить все данные */
    const handleBtnSave = () => {
        const validateData = validFormData([ // Валидируем данные 
            {fieldName: 'paymentNumber', value: txtPaymentNumber.value.toString(), validType: 'notEmpty', isRequired: true, errorMessage: 'Номер платежа из выписки.'},
            {fieldName: 'paymentDate', value: txtPaymentDate.value, validType: 'date', isRequired: true, errorMessage: 'Дата платежа из выписки не указана или не корректна.'},
            {fieldName: 'paymentSum', value: txtPaymentSum.value.toString().trim().replace(',', '.'), validType: 'numberDecimal', isRequired: true, errorMessage: 'Сумма платежа из выписки не указана.'},
            {fieldName: 'paymentPayer', value: txtPaymentPayer.value, validType: 'notEmpty', isRequired: true, errorMessage: 'Плательщик из выписки не указан.'},
        ])

        for (const item of validateData) { // Выводим ошибки валидации
            fieldsErrorAnimation(item.fieldName as FieldsErrorType)
            notify && notifyOpen(item.message, 'warning', 2000, notify)
        }

        if (validateData.length === 0) { // Сохраняем данные
            handlerButtonOk && handlerButtonOk(txtPaymentNumber.value, txtPaymentDate.value, Number(txtPaymentSum.value.toString().trim().replace(',', '.')), txtPaymentPayer.value, txtPaymentRefund.value)
        }
    }
    /** Активация анимации ошибки в указанных полях */
    const fieldsErrorAnimation = useFieldsErrorAnimation<IFieldsError>(fieldsError.setValue)


    const propsToComponent: ICardContractPayments = {
        isOpen, cardMode, 
        paymentNumber, paymentDate, paymentSum, paymentPayer, paymentRefund,

        fieldsError, txtPaymentRefund, txtPaymentNumber, txtPaymentDate, txtPaymentSum, txtPaymentPayer,
        handleBtnSave, handlerButtonCancel
    }

    return <>
        <CardContractPayments {...propsToComponent} />
    </>
}